import { render, staticRenderFns } from "./ImpactedCourses.vue?vue&type=template&id=c71227e6&scoped=true&"
import script from "./ImpactedCourses.vue?vue&type=script&lang=js&"
export * from "./ImpactedCourses.vue?vue&type=script&lang=js&"
import style0 from "./ImpactedCourses.vue?vue&type=style&index=0&id=c71227e6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c71227e6",
  null
  
)

export default component.exports